import { LogbookPage } from '@/modules/logbook';

export const Logbook = () => {
  return <LogbookPage />;
};
